import { render, staticRenderFns } from "./NewTemplateForm.vue?vue&type=template&id=0c473d09&scoped=true"
import script from "./NewTemplateForm.vue?vue&type=script&lang=js"
export * from "./NewTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./NewTemplateForm.vue?vue&type=style&index=0&id=0c473d09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c473d09",
  null
  
)

export default component.exports